"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONTextEditor = void 0;
var material_1 = require("@mui/material");
var react_1 = __importStar(require("react"));
function JSONTextEditor(_a) {
    var value = _a.value, onChange = _a.onChange;
    var _b = __read((0, react_1.useState)(JSON.stringify(value, null, '    ')), 2), textareaValue = _b[0], setTextareaValue = _b[1];
    var _c = __read((0, react_1.useState)(true), 2), isValid = _c[0], setIsValid = _c[1];
    var updateValue = function (newValue) {
        setTextareaValue(newValue);
        try {
            var parsedResult = JSON.parse(newValue);
            setIsValid(true);
            onChange(parsedResult);
        }
        catch (err) {
            setIsValid(false);
        }
    };
    (0, react_1.useEffect)(function () {
        setTextareaValue(JSON.stringify(value, null, '    '));
        setIsValid(true);
    }, [value]);
    return (react_1.default.createElement(material_1.TextField, { sx: {
            '& .MuiInputBase-root': {
                flex: 1,
            },
        }, margin: "dense", fullWidth: true, style: { flex: 1, margin: 0 }, inputProps: { style: { height: '100%', overflow: 'auto' } }, error: !isValid, hiddenLabel: true, autoCorrect: "off", spellCheck: "false", autoComplete: "off", multiline: true, variant: "outlined", onChange: function (e) { return updateValue(e.target.value); }, value: textareaValue }));
}
exports.JSONTextEditor = JSONTextEditor;
